import type { ReactNode } from "react";

import S from "./AdminPaneLayout.module.css";
import { AdminPaneTitle } from "./AdminPaneTitle";
import type { AdminPaneProps } from "./types";

type AdminPaneLayoutProps = AdminPaneProps & {
  children: ReactNode;
};

export const AdminPaneLayout = ({
  title,
  description,
  buttonText,
  buttonAction,
  buttonDisabled,
  children,
  buttonLink,
  headingContent,
  buttonIcon,
  isPeopleListing,
}: AdminPaneLayoutProps) => (
  <div data-testid="admin-panel" style={isPeopleListing ? {gap: "0", display: "flex", flexDirection: "column", alignItems: "end", justifyContent: "center", backgroundColor: "transparent", minWidth: "100%"} : {}} className={S.PaneLayout}>
    <AdminPaneTitle
      title={title}
      description={description}
      buttonText={buttonText}
      buttonAction={buttonAction}
      buttonDisabled={buttonDisabled}
      buttonLink={buttonLink}
      headingContent={headingContent}
      buttonIcon={buttonIcon}
      isPeopleListing={isPeopleListing}
    />
    {children}
  </div>
);
